import css_text from '/srv/www/htdocs/loc/app/styles/web_components/divider.css';

function get_shared_sheet() {
	if (get_shared_sheet.cached) {
		return get_shared_sheet.cached;
	}
	const sheet = new CSSStyleSheet();
	sheet.replaceSync(css_text);
	get_shared_sheet.cached = sheet;
	return sheet;
}

class YalwaDivider extends HTMLElement {

	static get observedAttributes() {
		return ['appearance', 'position', 'thickness'];
	}

	constructor() {
		super();
		this.hr = null;
		if (!this.shadowRoot) {
			this.attachShadow({mode: 'open'});
		}
		this.apply_css();
	}

	async apply_css() {
		await yalwa.basics.check_stylesheet_polyfill_needed();
		this.shadowRoot.adoptedStyleSheets = [get_shared_sheet()];
	}

	connectedCallback() {
		this.initialize_template();
		this.render();
		jQuery(this).removeClass('invisible');
	}

	initialize_template() {
		if (!this.shadowRoot.firstChild) {
			const template = document.createElement('template');
			template.innerHTML = '<hr role="separator" />';
			this.shadowRoot.appendChild(template.content.cloneNode(true));
		}
		this.hr = this.shadowRoot.querySelector('hr');
	}

	attributeChangedCallback(name, old_value, new_value) {
		if (old_value !== new_value && this.hr) {
			this.render();
		}
	}

	render() {
		if (!this.hr) {
			return;
		}

		const appearance = this.getAttribute('appearance') || 'default';
		const position = this.getAttribute('position') || 'horizontal';
		const thickness = this.getAttribute('thickness') || '1';

		this.hr.setAttribute('data-appearance', appearance);
		this.hr.setAttribute('data-position', position);
		this.hr.setAttribute('data-thickness', thickness);
		this.hr.setAttribute('aria-orientation', position === 'vertical' ? 'vertical' : 'horizontal');
	}
}

customElements.define('yalwa-divider', YalwaDivider);
